import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { JobCard } from "./JobsList";
import BlogSidebar from "./BlogSideBar";

// function BlogSidebar() {
//   const [blogs, setBlogs] = useState([]);

//   useEffect(() => {
//     let isMounted = true;
//     const controller = new AbortController();
    
//     axios
//       .get(constvar.api_url + "get_blog_list/6", { signal: controller.signal })
//       .then((res) => {
//         if (!isMounted) return;
//         if (res.data.status === "success") setBlogs(res.data.data || []);
//       })
//       .catch(error => {
//         if (!isMounted) return;
//         if (error.name !== "AbortError" && error.name !== "CanceledError") {
//           console.error("Failed to load blogs:", error);
//         }
//       });

//     // Cleanup: cancel request if component unmounts
//     return () => {
//       isMounted = false;
//       controller.abort();
//     };
//   }, []);

//   return (
//     <div className="sf-sidebar-widget">
//       <div className="sf-widget-header">
//         <h3>Latest Blog</h3>
//         <Link to="/blog">View All</Link>
//       </div>
//       <div className="sf-widget-body">
//         {blogs.length > 0 ? (
//           blogs.map((blog) => (
//             <Link
//               key={blog.id}
//               to={"/blog/" + blog.id}
//               className="sf-blog-item"
//               style={{ textDecoration: "none" }}
//             >
//               <div className="sf-blog-thumb">
//                 <img src={blog.image} alt={blog.title} />
//               </div>
//               <div className="sf-blog-info">
//                 <div className="sf-blog-title">{blog.title}</div>
//                 <div className="sf-blog-date">{blog.created_at}</div>
//               </div>
//             </Link>
//           ))
//         ) : (
//           <p style={{ fontSize: 12, color: "#94a3b8", margin: 0 }}>No blogs yet.</p>
//         )}
//       </div>
//     </div>
//   );
// }

export function LatestJobssss() {
  const [jobs, setJobs] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    
    axios
      .get(constvar.api_url + "jobs?per_page=12", { signal: controller.signal })

      .then((res) => {
        if (!isMounted) return;
        if (res.data.status === "success") setJobs(res.data.data.data || []);
      })
      .catch(error => {
        if (!isMounted) return;
        if (error.name !== "AbortError" && error.name !== "CanceledError") {
          console.error("Failed to load jobs:", error);
        }
      })
      .finally(() => setLoading(false));

    // Cleanup: cancel request if component unmounts
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);

  return (
    <section className="sf-section">
      <div className="sf-container">
        <div className="sf-section-header">
          <h2 className="sf-section-title">Latest Jobs</h2>
          <Link to="/job_search" className="sf-section-link">
            View All
          </Link>
        </div>

        <div className="sf-latest-layout">
          <div>
            {loading ? (
              <div className="sf-loading">
                <i className="fa fa-spinner fa-spin" /> Loading…
              </div>
            ) : jobs.length > 0 ? (
              <div className="sf-latest-grid">
                {jobs.map((job) => (
                  <JobCard key={job.id} job={job} />
                ))}
              </div>
            ) : (
              <div className="sf-empty">No latest jobs found.</div>
            )}
          </div>

          <div className="sf-sidebar">
            <BlogSidebar />
          </div>
        </div>
      </div>
    </section>
  );
}


export default function LatestJobs({ title, size, extraParams }) {
  const [employers, setEmployers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [expandedEmployer, setExpandedEmployer] = useState(null);

  const perPage = size || 12;
  const extra = extraParams || {};

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    const params = new URLSearchParams({ per_page: perPage, ...extra });
    axios
      .get(constvar.api_url + "jobs/grouped?" + params.toString(), {
        signal: controller.signal,
      })
      .then((res) => {
        if (!isMounted) return;
        if (res.data.status === "success") setEmployers(res.data.data.data || []);
      })
      .catch((error) => {
        if (!isMounted) return;
        if (error.name !== "AbortError" && error.name !== "CanceledError") {
          console.error("Failed to load jobs:", error);
        }
      })
      .finally(() => setLoading(false));

    return () => {
      isMounted = false;
      controller.abort();
    };
  }, [perPage, JSON.stringify(extra)]);

  const handleEmployerHover = (employerId) => {
    setExpandedEmployer(employerId);
  };

  const handleEmployerLeave = () => {
    setExpandedEmployer(null);
  };

  return (
    <section className="sf-section sf-section-light">
      <div className="sf-container">
        <div className="sf-section-header">
          <h2 className="sf-section-title">Latest Jobs</h2>
          <Link to="/job_search" className="sf-section-link">
            View All
          </Link>
        </div>

        {loading ? (
          <div className="sf-loading">
            <i className="fa fa-spinner fa-spin" /> Loading…
          </div>
        ) : employers.length > 0 ? (
          <div className="sf-groupby-employers-grid">
            {employers.map((employer) => {
              const isExpanded = expandedEmployer === employer.employer_id;
              const visibleJobs = isExpanded ? employer.jobs.slice(0, 7) : employer.jobs.slice(0, 2);
              const hasMoreJobs = employer.jobs.length > 2;
              const remainingCount = employer.jobs.length - 2;

              return (
                <div className="jobs_card">
                  <div
                    key={employer.employer_id}
                    className={`sf-groupby-employer-card ${isExpanded ? "sf-groupby-employer-card-expanded" : ""}`}
                    onMouseEnter={() => handleEmployerHover(employer.employer_id)}
                    onMouseLeave={handleEmployerLeave}
                  >
                    <div className="flex justify-between">
                      {/* Employer Header */}
                      <div className="sf-groupby-employer-header">
                        <div className="sf-groupby-employer-logo-wrapper">
                          <img
                            src={
                              employer.photo ||
                              "/default/default_company_logo.jpg"
                            }
                            alt={employer.comp_name}
                            className="sf-groupby-employer-logo"
                          />
                        </div>
                        <div className="sf-groupby-employer-name">
                          <h5><Link key={employer.employer_id} to={`/company/${employer.clientslug}`} className="sf-groupby-employer-name-link">{employer.comp_name || "N/A"}</Link></h5>
                          {visibleJobs.map((job) => (
                            <Link
                              key={job.id}
                              to={"/jobs/" + job.slug}
                              className="sf-groupby-employer-job-link"
                            >
                                {job.job_title.length > 25 
                                  ? `${job.job_title.substring(0, 25)}...` 
                                  : job.job_title
                                }
                            </Link>
                          ))}
                        </div>
                      </div>
                      {/* Expand Button - Show only if more than 2 jobs */}
                      {hasMoreJobs && (
                        <div className="sf-groupby-employer-expand-button">
                          <Link key={employer.employer_id} to={`/company/${employer.clientslug}`}>
                          <span className="sf-groupby-expand-text">
                          +{remainingCount} more
                          </span>
                          <i className="fa fa-chevron-down" />
                          </Link>
                        </div>
                      )}
                    </div>

                  </div>
                </div>
              );
            })}
          </div>
        ) : (
          <div className="sf-empty">No jobs available at the moment.</div>
        )}
      </div>
    </section>
  );
}